import { useSuspenseQuery } from '@apollo/client/react';
import { usePageContext } from '../../../../hooks/PageContext/usePageContext';
import translationsQueryByKey from '../../../../../../graphql/translationsQueryByKey';
import {
  NarvarStatusCode,
  GetTranslationsQueryVariables,
  Query,
} from '../../../../../../__generated__/loma';

const TrackingStatusText = ({
  status,
  statusCode,
  subStatus,
}: {
  status?: string;
  statusCode?: NarvarStatusCode;
  subStatus?: NarvarStatusCode | null;
}) => {
  const { state } = usePageContext();
  const {
    retailerMoniker,
    localeLanguage,
    localeCountry,
    versionName,
    type,
    cache,
  } = state;

  const stringifiedKeys = 'trackingStatus';

  const { data } = useSuspenseQuery<
    Pick<Query, 'retailerTranslations'>,
    GetTranslationsQueryVariables
  >(translationsQueryByKey(stringifiedKeys), {
    skip: !statusCode && !status,
    variables: {
      retailerMoniker,
      localeLanguage: localeLanguage || 'en',
      localeCountry,
      versionName,
      type,
      category: subStatus ?? statusCode,
      status,
      cache,
    },
  });

  const { trackingStatus } = data?.retailerTranslations ?? {};

  return <>{trackingStatus}</>;
};

export default TrackingStatusText;
